import { useState } from 'react';
import Navigation from 'components/Navigation';
import Saves from 'components/Saves';
import Directory from 'components/Directory';
import Copyright from 'components/Copyright';
import Page, { Content, Footer } from 'containers/Page';
import { ButtonLink, Input } from 'elements/Input';
import Box from 'elements/Box';
import { Label, Paragraph, ExternalLink } from 'elements/Text';
import routes, { queries } from 'routes';

const HomePage = () => {
  const [ input, setInput ] = useState();

  return (
    <Page>
      <Content>
        <Navigation />
        <Paragraph>Across Word lets you play crossword puzzles from <ExternalLink target="_blank" href="https://www.xwordinfo.com/JSON/">standard crossword JSON</ExternalLink> via URL. Input a URL below to load a game:</Paragraph>
        <Box display="flex" flexDirection="row" alignItems="center" gridGap="0.75rem" fluid>
          <Input onChange={e => setInput(e.target.value)} fluid/>
          <ButtonLink
            type="primary"
            to={`${routes.root}${routes.games.root}${queries.root}${queries.source(input)}`}
          >
            Open
          </ButtonLink>
        </Box>
        <Paragraph>
          Looking for game data? Check out this <ExternalLink target="_blank" href="https://docs.google.com/spreadsheets/d/1mCJ9DeouPFhy0CHuC28jDwFHkgZ2k3_LnXnzTZ45skE/edit#gid=0">Google Spreadsheet</ExternalLink>.
        </Paragraph>
        <Directory />
        <Label>Saved Crosswords:</Label>
        <Saves />
      </Content>
      <Footer>
        <Copyright />
      </Footer>
    </Page>
  );
}

export default HomePage;
